import { render, staticRenderFns } from "./MyReport.vue?vue&type=template&id=564f3f36&scoped=true&"
import script from "./MyReport.vue?vue&type=script&lang=js&"
export * from "./MyReport.vue?vue&type=script&lang=js&"
import style0 from "./MyReport.vue?vue&type=style&index=0&id=564f3f36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564f3f36",
  null
  
)

export default component.exports